import type { Monitoring } from '@protector/entities/monitoring/models';
import type { EntityAdapter, EntityState } from 'redux-ngrx-entity';
import { createEntityAdapter } from 'redux-ngrx-entity';
import * as MonitoringActions from './monitoring.actions';

const { MonitoringActionsTypes } = MonitoringActions;

type MonitoringActionsFunctions = Omit<typeof MonitoringActions, 'MonitoringActionsTypes'>;
type ActionsResponses = ReturnType<MonitoringActionsFunctions[keyof MonitoringActionsFunctions]>;

function selectMonitoringId(monitoring: Monitoring): string {
  return monitoring.id;
}

const entity: EntityAdapter<Monitoring> = createEntityAdapter<Monitoring>({
  selectId: selectMonitoringId
});

export interface MonitoringState extends EntityState<Monitoring> {
  isLoading: boolean;
  error?: string;
}
const initialState: MonitoringState = entity.getInitialState({
  isLoading: false
});

export default (state = initialState, action: ActionsResponses): MonitoringState => {
  switch (action.type) {
    case MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING:
      return entity.removeAll({
        ...state,
        isLoading: true
      });
    case MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING_SUCCESS:
      return entity.addAll(action.payload, {
        ...state,
        isLoading: false
      });
    case MonitoringActionsTypes.LOAD_AREA_DAY_MONITORING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const { selectAll } = entity.getSelectors();
export const selectAllMonitoring = selectAll;
